export enum TrackingEvent {
  DACBankSelectionStepShown = 'dac_bank_selection_step_shown',
  DACBankLoginStepShown = 'dac_bank_login_step_shown',
  DACTanStepShown = 'dac_tan_step_shown',
  DACBankCodeChange = 'dac_bank_code_change',
  DACIBANGateShown = 'dac_iban_gate_shown',
  DACIBANGateSkip = 'dac_iban_gate_skip',
  DACIBANGateContinue = 'dac_iban_gate_continue',
  FetchKey = 'fetch_key',
  FetchKeyError = 'fetch_key_error',
}
